// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  backendURL: 'https://api.qr-pay.club',
  // backendURL: 'http://localhost:1323',
  callbackURL: 'https://cpr.ricecashasia.com/paysavebt/serverCallback',
  googleURL : 'https://api.qr-pay.club',
  firebaseConfig: {
    apiKey: "AIzaSyAHWNIdjVivJcSqOqN86i-A68DNvnSGN2g",
    authDomain: "chooss-eshop.firebaseapp.com",
    databaseURL: "https://chooss-eshop.firebaseio.com",
    projectId: "chooss-eshop",
    storageBucket: "chooss-eshop.appspot.com",
    messagingSenderId: "715183488668",
    appId: "1:715183488668:web:7146989caae4afb8c0f759",
    measurementId: "G-69BNH8DKMJ"
  }
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
